export function haversineKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371;
  const toRad = (x: number) => (x * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export type BBox = [west: number, south: number, east: number, north: number];

export function inBBox(lat: number, lon: number, b: BBox): boolean {
  return lon >= b[0] && lon <= b[2] && lat >= b[1] && lat <= b[3];
}

/** Bounding box of a set of points, padded by a fraction of its size. */
export function bboxOf(points: { lat: number; lon: number }[], pad = 0.08): BBox | null {
  if (!points.length) return null;
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  for (const p of points) {
    if (p.lon < w) w = p.lon;
    if (p.lon > e) e = p.lon;
    if (p.lat < s) s = p.lat;
    if (p.lat > n) n = p.lat;
  }
  const dx = Math.max(e - w, 0.02) * pad;
  const dy = Math.max(n - s, 0.02) * pad;
  return [w - dx, s - dy, e + dx, n + dy];
}

export const IRELAND_BOUNDS: BBox = [-11.2, 51.0, -5.0, 55.8];
export const IRELAND_CENTER: [number, number] = [-7.9, 53.4];
